import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import ConsumerMailboxOptions from 'owa-service/lib/contract/ConsumerMailboxOptions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export let resetConsumerDefaultFromStore = mutatorAction(
    'resetConsumerDefaultFromStore',
    (options: ConsumerMailboxOptions) => {
        let store = connectedAccountsStore();
        store.defaultFromState.emailAddresses = [];
        store.defaultFromState.consumerMailboxOptions = options;
        let sessionSettings = getUserConfiguration().SessionSettings;
        let emailAddresses = [];

        let defaultAddress =
            options.DefaultFromAddress ||
            sessionSettings.DefaultFromAddress ||
            sessionSettings.UserEmailAddress;
        store.defaultFromState.defaultFromAddress = defaultAddress;
        store.defaultFromState.emailAddresses.push({
            key: emailAddresses.length.toString(),
            text: store.defaultFromState.defaultFromAddress,
        });
        emailAddresses.push(store.defaultFromState.defaultFromAddress);

        let userProxyAddresses = options.EmailAddresses;
        if (userProxyAddresses && userProxyAddresses.length > 0) {
            for (let emailAddress of userProxyAddresses) {
                if (emailAddresses.indexOf(emailAddress) < 0) {
                    store.defaultFromState.emailAddresses.push({
                        key: emailAddresses.length.toString(),
                        text: emailAddress,
                    });
                    emailAddresses.push(emailAddress);
                }
            }
        }

        let notManagedEmailAddresses = options.NotManagedEmailAddresses;
        if (notManagedEmailAddresses && notManagedEmailAddresses.length > 0) {
            for (let emailAddress of notManagedEmailAddresses) {
                if (emailAddresses.indexOf(emailAddress) < 0) {
                    store.defaultFromState.emailAddresses.push({
                        key: emailAddresses.length.toString(),
                        text: emailAddress,
                    });
                    emailAddresses.push(emailAddress);
                }
            }
        }

        let accounts = options.SendEnabledConnectedAccounts;
        if (accounts && accounts.length > 0) {
            for (let account of accounts) {
                if (emailAddresses.indexOf(account.EmailAddress) < 0) {
                    store.defaultFromState.emailAddresses.push({
                        key: emailAddresses.length.toString(),
                        text: account.EmailAddress,
                    });
                    emailAddresses.push(account.EmailAddress);
                }
            }
        }
    }
);
